import { __decorate } from "tslib";
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { requiredProperty } from '@/helpers/mixins/LocalizationHelper';
import { AlertType } from '@/helpers/entities/enums/AlertType';
import PhotoMixin from '@/helpers/vue_mixins/v2/PhotoMixin';
import OrangeThemeMixin from '@/helpers/vue_mixins/v2/OrangeThemeMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import AppDetailsMixin from '@/helpers/vue_mixins/v2/ecommerce/AppDetailsMixin';
import FormHeader from '@/components/v2/FormHeader.vue';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import ActionButton from '@/components/action_button/Index.vue';
import { PsgcCityModel } from '@/helpers/entities/models/PsgcCityModel';
import { PsgcRegionModel } from '@/helpers/entities/models/PsgcRegionModel';
import { required, email, requiredIf } from 'vuelidate/lib/validators';
import PhoneInput from '@/components/v2/PhoneInput.vue';
import DefaultBillingAddress from '@/plugins/graphql/queries/v2/default-billing-address.gql';
import PsgcRegions from '@/plugins/graphql/queries/v2/psgc-all-regions.gql';
import PsgcCities from '@/plugins/graphql/queries/v2/psgc-all-cities.gql';
import PaymentMethod from '@/plugins/graphql/queries/v2/payment-method.gql';
import EditXenditBillingAddress from '@/plugins/graphql/mutations/edit-xendit-billing-address.gql';
let PaymentPreferencesCreate = class PaymentPreferencesCreate extends Mixins(PhotoMixin, OrangeThemeMixin, ViewportSizeMixin, AppDetailsMixin, Mixins(FormMixin, FormValidationsMixin, RouterParamsAppMixin)) {
    constructor() {
        super(...arguments);
        this.form = {
            firstName: null,
            lastName: null,
            country: null,
            address: null,
            city: null,
            stateProvinceRegion: null,
            zip: null,
            mobile: null,
            email: null,
            isDefault: null,
            company: null,
        };
        this.defaultAddress = null;
        this.selectedPaymentMethod = null;
        this.autoFillAddress = false;
        this.accountNumberDisplay = '';
        this.paymentMethodDisplay = '';
        this.selectedRegionCode = '0';
        this.regionSelection = [];
        this.citySelection = [];
    }
    onAutoFillAddressChange() {
        const vm = this;
        if (vm.autoFillAddress && vm.defaultAddress) {
            this.handleRegionChange(vm.defaultAddress.stateProvinceRegion);
            this.form.firstName = vm.defaultAddress.firstName;
            this.form.lastName = vm.defaultAddress.lastName;
            this.form.country = vm.defaultAddress.country;
            this.form.address = vm.defaultAddress.address;
            this.form.city = vm.defaultAddress.city;
            this.form.stateProvinceRegion = vm.defaultAddress.stateProvinceRegion;
            this.form.zip = vm.defaultAddress.zipPostalCode;
            this.form.email = vm.defaultAddress.billingContactEmail;
            this.form.company = vm.defaultAddress.company;
        }
        else {
            this.handleRegionChange(vm.selectedPaymentMethod.billingAddress.stateProvinceRegion);
            this.form.firstName = vm.selectedPaymentMethod.billingAddress.firstName;
            this.form.lastName = vm.selectedPaymentMethod.billingAddress.lastName;
            this.form.country = vm.selectedPaymentMethod.billingAddress.country;
            this.form.address = vm.selectedPaymentMethod.billingAddress.address;
            this.form.city = vm.selectedPaymentMethod.billingAddress.city;
            this.form.stateProvinceRegion = vm.selectedPaymentMethod.billingAddress.stateProvinceRegion;
            this.form.zip = vm.selectedPaymentMethod.billingAddress.zipPostalCode;
            this.form.mobile = vm.selectedPaymentMethod.billingAddress.phoneNumber;
            this.form.email = vm.selectedPaymentMethod.billingAddress.billingContactEmail;
            this.form.company = vm.selectedPaymentMethod.billingAddress.company;
        }
    }
    accountNumberDisplaySelect(method) {
        if (method.card) {
            this.accountNumberDisplay = method.card.card_information.masked_card_number;
            this.paymentMethodDisplay = method.card.card_information.network;
        }
        if (method.directDebit) {
            this.accountNumberDisplay = method.directDebit.bank_account.masked_bank_account_number;
            this.paymentMethodDisplay = this.directDebitNames(method.directDebit.channel_code);
        }
        if (method.ewallet) {
            this.accountNumberDisplay = method.ewallet.account.account_details;
            this.paymentMethodDisplay = method.ewallet.channel_code;
        }
    }
    directDebitNames(name) {
        if (name === 'UBP') {
            return 'UnionBank';
        }
        return '';
    }
    async fetchDefaultAddress() {
        try {
            const data = await this.$apollo.query({
                query: DefaultBillingAddress,
                variables: {
                    appUuid: this.appUUID,
                },
            });
            const address = data.data.fetchDefaultPaymentMethod.billingAddress;
            this.defaultAddress = address;
        }
        catch (error) {
            this.errorNotification(error.message);
        }
    }
    async fetchPaymentMethod() {
        try {
            const data = await this.$apollo.query({
                query: PaymentMethod,
                variables: {
                    xenditPaymentMethodUuid: this.$route.params.uuid,
                },
            });
            const method = data.data.fetchSelectedPaymentMethod;
            this.selectedPaymentMethod = method;
            if (method) {
                this.form.firstName = method.billingAddress.firstName;
                this.form.lastName = method.billingAddress.lastName;
                this.form.country = method.billingAddress.country;
                this.form.address = method.billingAddress.address;
                this.form.city = method.billingAddress.city;
                this.form.stateProvinceRegion = method.billingAddress.stateProvinceRegion;
                this.form.zip = method.billingAddress.zipPostalCode;
                this.form.mobile = method.billingAddress.phoneNumber;
                this.form.email = method.billingAddress.billingContactEmail;
                this.form.company = method.billingAddress.company;
            }
        }
        catch (error) {
            this.errorNotification(error.message);
        }
    }
    async fetchRegions() {
        try {
            const data = await this.$apollo.query({
                query: PsgcRegions,
            });
            if (data) {
                const psgcRegions = data.data.allPsgcRegions.edges;
                const psgcRegionNode = (sc) => {
                    return new PsgcRegionModel(sc.node);
                };
                this.regionSelection = psgcRegions.map(psgcRegionNode);
            }
        }
        catch (error) {
            this.errorNotification(error.message);
        }
    }
    handleRegionChange(selectedRegionName) {
        // Find the region object with the matching name
        const selectedRegion = this.regionSelection.find((region) => region.name === selectedRegionName);
        // Check if selectedRegion is found
        if (selectedRegion) {
            // Access the regionCode property of the selected region
            const { regionCode } = selectedRegion;
            this.selectedRegionCode = regionCode;
        }
        else {
            this.selectedRegionCode = '0';
        }
        this.$apollo.queries.cities.refetch();
    }
    formCallback() {
        const message = 'Successfully Edited Xendit Payment Method';
        this.toggleAlert(message, AlertType.success);
    }
    async submit() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
            this.isRequestOnProcess = true;
            const mutation = this.editPaymentMethod();
            await mutation
                .then(() => {
                this.formCallback();
                this.$router.push({ name: this.$route.params.from });
            })
                .catch((error) => {
                this.errorNotification(error.message);
            })
                .finally(() => {
                this.isRequestOnProcess = false;
            });
        }
    }
    isValidMobile(mobileNumber) {
        // Remove all spaces from the input
        if (mobileNumber) {
            const cleanedNumber = mobileNumber.replace(/\s/g, '');
            // Test against the regex for the cleaned number
            const phoneNumberRegex = /^\+639\d{9}$/;
            return phoneNumberRegex.test(cleanedNumber);
        }
        return false;
    }
    async editPaymentMethod() {
        const vm = this;
        return this.$apollo.mutate({
            mutation: EditXenditBillingAddress,
            variables: {
                input: {
                    xenditBillingAddressUuid: vm.selectedPaymentMethod.billingAddress.uuid,
                    firstName: this.form.firstName,
                    lastName: this.form.lastName,
                    country: this.form.country,
                    address: this.form.address,
                    city: this.form.city,
                    stateProvinceRegion: this.form.stateProvinceRegion,
                    zipPostalCode: this.form.zip,
                    phoneNumber: this.form.mobile,
                    billingContactEmail: this.form.email,
                    company: this.form.company,
                },
            },
        });
    }
    get firstNameErrors() {
        const errors = [];
        if (!this.$v.form.firstName.$dirty) {
            return errors;
        }
        if (!this.$v.form.firstName.required) {
            const msg = requiredProperty('First Name');
            errors.push(msg);
        }
        if (!this.$v.form.firstName.invalidFirstName) {
            const msg = 'First Name Contains Invalid Characters';
            errors.push(msg);
        }
        return errors;
    }
    get lastNameErrors() {
        const errors = [];
        if (!this.$v.form.lastName.$dirty) {
            return errors;
        }
        if (!this.$v.form.lastName.required) {
            const msg = requiredProperty('Last Name');
            errors.push(msg);
        }
        if (!this.$v.form.lastName.invalidLastName) {
            const msg = 'Last Name Contains Invalid Characters';
            errors.push(msg);
        }
        return errors;
    }
    hasUrl(name) {
        const urlRegex = new RegExp('([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?');
        return !urlRegex.test(name);
    }
    get phoneErrors() {
        const errors = [];
        if (!this.$v.form.mobile.$dirty) {
            return errors;
        }
        if (!this.$v.form.mobile.required) {
            const msg = requiredProperty('Mobile Number');
            errors.push(msg);
        }
        if (!this.$v.form.mobile.invalidMobile) {
            const msg = 'Mobile Number is invalid';
            errors.push(msg);
        }
        return errors;
    }
    mounted() {
        this.fetchRegions();
    }
};
__decorate([
    Watch('autoFillAddress')
], PaymentPreferencesCreate.prototype, "onAutoFillAddressChange", null);
PaymentPreferencesCreate = __decorate([
    Component({
        components: {
            BaseTextField,
            ActionButton,
            FormHeader,
            PhoneInput,
        },
        validations() {
            const notRequired = () => false;
            const validations = {
                form: {
                    firstName: {
                        required,
                        invalidFirstName() {
                            const vm = this;
                            const { firstName } = this.form;
                            return vm.hasUrl(firstName);
                        },
                    },
                    lastName: {
                        required,
                        invalidLastName() {
                            const vm = this;
                            const { lastName } = this.form;
                            return vm.hasUrl(lastName);
                        },
                    },
                    country: {
                        required: requiredIf(notRequired),
                    },
                    address: {
                        required,
                    },
                    city: {
                        required,
                    },
                    stateProvinceRegion: {
                        required,
                    },
                    zip: {
                        required,
                    },
                    mobile: {
                        required,
                        invalidMobile() {
                            const vm = this;
                            const { mobile } = this.form;
                            return vm.isValidMobile(mobile);
                        },
                    },
                    email: {
                        required,
                        email,
                    },
                    isDefault: {
                        required: requiredIf(notRequired),
                    },
                    company: {
                        required: requiredIf(notRequired),
                    },
                },
            };
            return validations;
        },
        apollo: {
            cities: {
                query: PsgcCities,
                variables() {
                    return {
                        regionCode: this.selectedRegionCode,
                    };
                },
                fetchPolicy: 'cache-and-network',
                update(data) {
                    const psgcCities = data.filteredPsgcCities.edges;
                    const psgcRegionNode = (sc) => {
                        return new PsgcCityModel(sc.node);
                    };
                    this.citySelection = psgcCities.map(psgcRegionNode);
                    return this.citySelection;
                },
            },
            savedPaymentMethods: {
                query: PaymentMethod,
                variables() {
                    const vm = this;
                    return {
                        xenditPaymentMethodUuid: vm.$route.params.uuid,
                    };
                },
                fetchPolicy: 'cache-and-network',
                update(data) {
                    const method = data.fetchSelectedPaymentMethod;
                    this.selectedPaymentMethod = method;
                    if (method) {
                        this.handleRegionChange(method.billingAddress.stateProvinceRegion);
                        this.accountNumberDisplaySelect(method);
                        this.form.firstName = method.billingAddress.firstName;
                        this.form.lastName = method.billingAddress.lastName;
                        this.form.country = method.billingAddress.country;
                        this.form.address = method.billingAddress.address;
                        this.form.city = method.billingAddress.city;
                        this.form.stateProvinceRegion = method.billingAddress.stateProvinceRegion;
                        this.form.zip = method.billingAddress.zipPostalCode;
                        this.form.mobile = method.billingAddress.phoneNumber;
                        this.form.email = method.billingAddress.billingContactEmail;
                        this.form.company = method.billingAddress.company;
                    }
                },
            },
            defaultAddressQuery: {
                query: DefaultBillingAddress,
                variables() {
                    return {
                        appUuid: this.$route.params.appUUID,
                    };
                },
                fetchPolicy: 'cache-and-network',
                update(data) {
                    const address = data.fetchDefaultPaymentMethod.billingAddress;
                    this.defaultAddress = address;
                },
            },
        },
    })
], PaymentPreferencesCreate);
export default PaymentPreferencesCreate;
